import React from 'react'
import moment from 'moment'
import BarcodeCom from '../donors/BarcodeCom'
import Footer from '../controls/Footer'
import SafeImage, { SIGNATURE_PLACEHOLDER } from '../controls/SafeImage'

const getDesc=(val)=>{
  return(
    (val && val.toUpperCase()==='Y')? 'Yes' : (val && val.toUpperCase()==='N')? 'No':  (val && val.toUpperCase()==='/')? 'N/A' : ''
  )
}

//  margin-top, margin-right, margin-bottom, and margin-left.
const tableStyle = {
    margin: "auto",  
    width:"100%" ,  
    borderCollapse:"collapse",
    padding: "0",
    textAlign: "left",
    fontSize: "9px",
  };

  const tableStyleCenter = {
    margin: "auto",  
    width:"100%" ,  
    borderCollapse:"collapse",
    padding: "0",
    textAlign: "center",
    fontSize: "9px"
  };

const outerTable = {
    margin: "20px 10px 0px 20px",   
    borderCollapse:"collapse",
    padding: "0",
    width: "780px",

  };

const hiddenStyle = {
    visibility: "hidden"
}

class ShowPrint extends React.Component {

  constructor(props){
    super(props)
  }
  
 

render(props) {
     const record= this.props.record
     const classes = this.props.classes
     return(
      <div >
      <table   cellPadding="10" cellSpacing="0" style={outerTable}>
          <tbody>
              <tr>
                  <td>
                  <table border='0' cellPadding="0" cellSpacing="0"  style={tableStyle}>
                            <tbody>
                            <tr>
                                <td style={{fontSize: '20px', fontWeight: 'bold', textAlign:'center' }}>DONOR PROCESSING WORKSHEET</td>
                            </tr>
                            <tr>
                                <td >
                                    <table border='1' cellPadding="3" cellSpacing="0"  style={tableStyle}>
                                    <tbody>
                                    <tr>
                                        <td>Name: &nbsp;&nbsp;{record.name}</td>
                                        <td>Donor #: &nbsp;&nbsp;{record.ssn}</td>
                                        <td>Date: &nbsp;&nbsp;{moment(record.bleed_date).format('MM/DD/YYYY')}</td>
                                    </tr>
                                    </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td >
                                    <table   border='1' cellPadding="5" cellSpacing="0" style={tableStyle}>
                                    <tbody>
                                    <tr>
                                        <td>Donor Processor Initial For Donor Record File Review:&nbsp;&nbsp;{record.initial_review}</td>                      
                                        <td>CDCS Inquiry Number:&nbsp;&nbsp;{record.cdcs_inq_num}</td>
                                    </tr>
                                    </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td >
                                    <table   border='1' cellPadding="3" cellSpacing="0" style={tableStyle}>
                                    <tbody>
                                        <tr>
                                            <td colSpan="2">Donor database check for internal deferrals: Acceptable?&nbsp;&nbsp;{getDesc(record.deferrals_accept)}</td>
                                            
                                        </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td >
                                <table border='1' cellPadding="3" cellSpacing="0" style={tableStyle}>
                                <tbody>
                                        <tr>
                                            <td>Is your current address and phone number good for the next 8 weeks?&nbsp;&nbsp;{getDesc(record.is_phone_good)}</td>
                                        </tr>
                                        </tbody>
                                </table>               
                                </td>
                            </tr>
                            </tbody>
                        </table>

                        <div style={{marginTop:"2px"}}>
                        <table border='1' cellPadding="5" cellSpacing="0"  style={tableStyle}>
                        <tbody>
                            <tr>
                                <td colSpan="4" style={{textAlign:'center', fontSize: '14px', fontWeight: 'bold'}}>Donor History Questionnaire</td>
                            </tr>
                            <tr>
                                <td style={{width:'38%'}}></td><td style={{width:'6%', fontWeight:'bold', textAlign:'center'}}>Yes / No</td>
                                <td style={{width:'38%'}}><b>Since you last donated plasma:</b></td><td  style={{width:'6%', fontWeight:'bold', textAlign:'center'}}>Yes / No</td>
                            </tr>
                            <tr>
                                <td>1. Are you feeling healthy and well today?</td>
                                <td style={{textAlign:'center'}}>{getDesc(record.healthy)}</td>
                                <td>11. Have you gotten a tattoo or had one touched up?</td>
                                <td style={{textAlign:'center'}}>{getDesc(record.tattoo)}</td>
                            </tr>
                            <tr>
                                <td>2. Since you last donated plasma have you taken any medications on the medication list?</td>
                                <td style={{textAlign:'center'}}>{getDesc(record.any_medications)}</td>
                                <td>12. Have you had an ear or body piercing?</td>
                                <td style={{textAlign:'center'}}>{getDesc(record.piercing)}</td>
                            </tr>
                            <tr>
                                <td><b>Since you last donated plasma:</b></td>
                                <td style={{textAlign:'center', fontWeight:'bold'}}>Yes / No</td>
                                <td>13. Have you had surgery or a diagnostic, medical or dental procedure?</td>
                                <td style={{textAlign:'center'}}>{getDesc(record.surgery)}</td>
                            </tr>
                            <tr>
                                <td>3. Female donors:  Have you been pregnant or are you pregnant now?</td>
                                <td style={{textAlign:'center'}}>{getDesc(record.pregnant)}</td>
                                <td>14. Have you had acupunture?</td>
                                <td style={{textAlign:'center'}}>{getDesc(record.acupunture)}</td>
                            </tr>
                            <tr>
                                <td>4. Have you had any new medical problems or diagnoses?</td>
                                <td style={{textAlign:'center'}}>{getDesc(record.new_problem)}</td>
                                <td><b>Additional Questions</b></td>
                                <td style={{textAlign:'center', fontWeight:'bold'}}>Yes / No</td>
                            </tr>
                            <tr>
                                <td>5. Have you had any new medical treatments, vaccinations or medications?</td>
                                <td style={{textAlign:'center'}}>{getDesc(record.new_medication)}</td>
                                <td>15. Have you ever received a xenotransplantation product?</td>
                                <td style={{textAlign:'center'}}>{getDesc(record.xenotran)}</td>
                            </tr>
                            <tr>
                                <td>6. Have you had contact with someone who had a smallpox vaccination?</td>
                                <td style={{textAlign:'center'}}>{getDesc(record.smallpox)}</td>
                                <td>16. Have you had Ebola Virus infection or disease?</td>
                                <td style={{textAlign:'center'}}>{getDesc(record.ebola)}</td>
                            </tr>
                            <tr>
                                <td>7. Have you donated whole blood, platelets or plasma at another center?</td>
                                <td style={{textAlign:'center'}}>{getDesc(record.other_center)}</td>
                                <td rowSpan="3">17. Have you had close contact in the past 8 weeks with a person confirmed to have Ebola virus infection or disease or a person under investigation for Ebola virus infection or disease in whom diagnosis is pending?</td>
                                <td rowSpan="3" style={{textAlign:'center'}}>{getDesc(record.ebola_contact)}</td>
                            </tr>
                        
                            <tr>
                                <td><b>Please review the Risk Poster</b></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>8. Did you review the Risk Poster?</td>
                                <td style={{textAlign:'center'}}>{getDesc(record.risk_poster)}</td>
                            </tr>
                            <tr>
                                <td>9. Do you have any questions about anything mentioned on the Risk Poster?</td>
                                <td style={{textAlign:'center'}}>{getDesc(record.risk_poster_question)}</td>
                                <td rowSpan="2">18. Did you receive a notification by public health authority that you may have been exposed in the past 8 weeks to a person with EVD?</td>
                                <td rowSpan="2" style={{textAlign:'center'}}>{getDesc(record.evd_exposed)}</td>
                            </tr>
                            <tr>
                                <td>10. Since you last donated plasma, does anything on the Risk Poster apply to you?</td>
                                <td style={{textAlign:'center'}}>{getDesc(record.risk_poster_apply_you)}</td>
                            </tr>
                            </tbody>
                        </table>
                        <div style={{marginTop:"3px"}}>
                            <table border='1' cellPadding="5" cellSpacing="0"  style={tableStyle}>
                            <tbody>
                                <tr>
                                    <td>General appearance: Acceptable? &nbsp;&nbsp;&nbsp;{getDesc(record.appearance)}</td>
                                    <td>Arm check: Visual Inspection: Acceptable? &nbsp;&nbsp;&nbsp;{getDesc(record.arm_check)}</td>
                                </tr>
                                <tr>
                                    <td colSpan="2">Donor Processor Initials For Donor History and Arm Check: &nbsp;&nbsp;&nbsp;{getDesc(record.donor_processor_int_arm_check)}</td>
                                </tr>
                                </tbody>
                            </table>    
                        </div>
                    
                        <table border='1' cellPadding="5" cellSpacing="0"  style={tableStyleCenter}>
                        <tbody>
                            <tr>
                                <th>Booth#</th>
                                <th>Start Time</th>
                                <th>Weight<br/>110-400 lbs</th>
                                <th>Collected Volume<br/>690, 825, 880 ml</th>
                                <th>Blood Pressure<br/>100-180/50-100 mmHg</th>
                                <th>Pulse<br/>56-100 bpm</th>
                                <th>Temperature<br/>97-99.4 F</th>
                                <th>Hematocrit<br/>Female:38%-54%<br/>Male:39%-54%</th>
                                <th>Total<br/>Protein 6.0-9.0 g/dl</th>
                                <th>Donor<br/>Processor Initials</th>
                            </tr>
                            <tr>
                                <td>{record.booth_num}</td>
                                <td>{record.start_time}</td>
                                <td>{record.weight}</td>
                                <td>{record.volume_collected}</td>
                                <td>{record.blood_pressure}</td>
                                <td>{record.pulse}</td>
                                <td>{record.temperature}</td>
                                <td>{record.hematocrit}</td>
                                <td>{record.total_protein}</td>
                                <td>{record.donor_processor_init}</td>
                            </tr>
                            <tr>
                                <td colSpan="10" style={{textAlign:'left'}} >Screening Comments:&nbsp;&nbsp;&nbsp;{record.comments_screening}</td>
                            </tr>
                            </tbody>
                        </table>
                        <table border='1' cellPadding="5" cellSpacing="0"  style={tableStyleCenter}>
                        <tbody>
                            <tr>
                                <td rowSpan="2" style={{width:'50%'}} >
                                    <table border='0' cellPadding="5" cellSpacing="0"  style={tableStyle}>
                                    <tbody>
                                        <tr>
                                            <td colSpan="2"><b>Donor Acknowledgment:</b></td>
                                        </tr>
                                        <tr>
                                            <td>1.</td><td>I have reviewed the educational material regarding infections that can be transmittend by my donation, such as, Syphilis, HIV, Hepatitis B and C.</td>
                                        </tr>
                                        <tr>
                                            <td>2.</td><td>I agree not to donate if my donation could result in a potential risk to people who receive plasma products.</td>
                                        </tr>
                                        <tr>
                                            <td>3.</td><td>A sample of my blood will be tested for infections that can be transmitted by my donation, such as, Syphilis, HIV, Hepatitis B and C.</td>
                                        </tr>
                                        <tr>
                                            <td>4.</td><td>I understand you will attempt to notify me if for any reason I cannot donate and records will be maintained indicating the reason for the deferral and the deferral time period.</td>
                                        </tr>
                                        <tr>
                                            <td>5.</td><td>I have reviewed the information regarding the potential risks and hazards of donating Source plasma.</td>
                                        </tr>
                                        <tr>
                                            <td>6.</td><td>I have been given opportunity to ask questions and understand that I may withdraw frm the donation procedure at any time.<br /><br/></td>
                                        </tr>
                                        <tr>
                                            <td colSpan="2"><b>Donor Signature:</b> &nbsp;&nbsp;&nbsp;<SafeImage
                                                                                                        src={record.donor_signature}
                                                                                                        fallbackSrc={SIGNATURE_PLACEHOLDER}
                                                                                                        alt="Donor signature"
                                                                                                        className={classes.image}
                                                                                                        name= "donor_signature"
                                                                                                        /></td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </td>
                                <th style={{height: '40px'}}>Physician Substitute Review from Donors Requiring Physical (Ini. Req.)</th>
                                <td style={{height: '40px'}}>{record.phy_sub_review}</td>
                                <th style={{height: '40px'}}>Control Desk Review</th>
                                <td style={{height: '40px', width:'15%'}}>{record.control_review}</td>
                            </tr>
                            <tr>
                                <td colSpan="4">
                                    <b>Control Number:</b>
                                    <BarcodeCom value={record && record.control_num ? `${record.control_num}` : ''} />
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <table border='1' cellPadding="5" cellSpacing="0"  style={tableStyleCenter}>
                        <tbody>
                            <tr>
                                <th>Quantity used: Plasmacell-C Kit</th>
                                <th>Quantity used: A/C</th>
                                <th>Quantity used: Saline</th>
                                <th>Quantity used: Bottle</th>
                                <th>Quantity used: Needle</th>
                                <th>Machine #</th>
                                <th>Arm used</th>
                                <th>Start time</th>
                                <th>Tech. Initial</th>
                                <th>Sample Collected</th>
                                <th>Disconnect Time</th>
                                <th>Volume Collected</th>
                                <th>D/C Tech. Initial</th>
                            </tr>
                            <tr>
                                <td>{record.ckit}</td>
                                <td>{record.qty_ac}</td>
                                <td>{record.qty_saline}</td>
                                <td>{record.qty_bottle}</td>
                                <td>{record.qty_needle}</td>
                                <td>{record.pcs_num}</td>
                                <td>{record.arm_used}</td>
                                <td>{record.process_start_time}</td>
                                <td>{record.tech_init}</td>
                                <td>{getDesc(record.sample_collected)}</td>
                                <td>{record.disc_time}</td>
                                <td>{record.volume_collected_2}</td>
                                <td>{record.dc_tech_init}</td>
                            </tr>
                            <tr>
                                <td colSpan='13' style={{textAlign:'left'}}>
                                    <b>Donation Comments:</b>&nbsp;&nbsp;&nbsp;{record.comments_donnor}
                                </td>
                            </tr>
                            <tr>
                                <td colSpan='13' style={{textAlign:'left'}}>
                                    <b>Incident:</b>&nbsp;&nbsp;&nbsp;{record.incident}
                                </td>
                            </tr>
                            <tr>
                                <td colSpan='13' style={{textAlign:'left'}}>
                                    <b>Processing/Packing Comments:</b>&nbsp;&nbsp;&nbsp;{record.comments_packing}<br/><br/>
                                    <b> Donor drank 20oz Gatorade:</b>&nbsp;&nbsp;&nbsp;{record.donor_gatorade}
                                </td>
                            </tr>
                            <tr>
                                <td colSpan='5' style={{textAlign:'left'}}>
                                    <b>Lab QA Review & Payout Initial:</b>&nbsp;&nbsp;&nbsp;{record.lab_init}
                                </td>
                                <td colSpan='8' style={{textAlign:'left'}}>
                                    <b>QA Initial/Date:</b>&nbsp;&nbsp;&nbsp;{record.qa_review_init}&nbsp;&nbsp;{((record.qa_review_date)? moment(record.qa_review_date).format('MM/DD/YYYY') : '') }
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        </div>
                  </td>
              </tr>
          </tbody>
      </table>
 
    <Footer >
        <span>Edonorsoft SOP Form No. 02.20.01, Effective 05-27-20</span>
    </Footer>
   
 </div>
     )
    }
}

export default ShowPrint